import type { RestoreWizardConfig } from '../types'

export const REF_WIZARD_CONFIG: RestoreWizardConfig = {
  kind: 'REF',
  kindLabel: 'Ref Restore',
  unitIds: { select: 'ref-wz-1', repositories: 'ref-wz-2', selectRef: 'ref-wz-3', targets: 'ref-wz-4', plan: 'ref-wz-5', order: 'ref-wz-6' },
  targetScopeForm: 'REPOSITORIES',
  singleRef: true,
}
